import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { DummyImg, TaskDone } from "../../images";

const questions = [
  {
    id: 1,
    question:
      "Which of the following is the primary purpose of conducting a pre-call analysis before meeting a healthcare professional?",
    options: [
      "To plan the call objective and understand the doctor's prescribing behavior",
      "To identify the best time to leave the office",
      "To finalize the expense report for the day",
      "To rehearse a product’s generic name pronunciation",
    ],
  },
  {
    id: 2,
    question:
      "Which of the following is the primary purpose of conducting a pre-call analysis before meeting a healthcare professional?",
    options: [
      "To plan the call objective and understand the doctor's prescribing behavior",
      "To identify the best time to leave the office",
      "To finalize the expense report for the day",
      "To rehearse a product’s generic name pronunciation",
    ],
  },
  {
    id: 3,
    question:
      "Which of the following is the primary purpose of conducting a pre-call analysis before meeting a healthcare professional?",
    options: [
      "To plan the call objective and understand the doctor's prescribing behavior",
      "To identify the best time to leave the office",
      "To finalize the expense report for the day",
      "To rehearse a product’s generic name pronunciation",
    ],
  },
  {
    id: 4,
    question:
      "Which of the following is the primary purpose of conducting a pre-call analysis before meeting a healthcare professional?",
    options: [
      "To plan the call objective and understand the doctor's prescribing behavior",
      "To identify the best time to leave the office",
      "To finalize the expense report for the day",
      "To rehearse a product’s generic name pronunciation",
    ],
  },
  {
    id: 5,
    question:
      "Which of the following is the primary purpose of conducting a pre-call analysis before meeting a healthcare professional?",
    options: [
      "To plan the call objective and understand the doctor's prescribing behavior",
      "To identify the best time to leave the office",
      "To finalize the expense report for the day",
      "To rehearse a product’s generic name pronunciation",
    ],
  },
];

const ActualTest = () => {
  const [isStarted, setIsStarted] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [showModal, setShowModal] = useState(false); // ✅ modal state

  const navigate = useNavigate();

  const handleStartTest = () => setIsStarted(true);

  const handleOptionClick = (index) => setSelectedOption(index);

  const handleNext = () => {
    if (currentQuestion === questions.length - 1) {
      setShowModal(true); // ✅ show modal instead of navigating
    } else {
      setSelectedOption(null);
      setCurrentQuestion((prev) => prev + 1);
    }
  };

  const handleModalNavigate = () => {
    setShowModal(false);
    navigate("/test"); // ✅ navigate when modal button clicked
  };

  const current = questions[currentQuestion];

  return (
    <div className="lms-body">
      <div className="lms-content-wrapper lms-content-text">
        <div className="lms-ceontent-course">
          <div className="test-wrapper p-4">
            <div className="d-flex justify-content-between align-items-center pb-3 lms-comman">
              <Button variant="primary" onClick={handleStartTest}>
                START TEST
              </Button>
              <h4 className="text-muted fw-bold">Timer: 05:00</h4>
            </div>

            <div className="question-section p-3 rounded mt-3">
              <h4 className="text-muted fw-bold mb-1">
                Pre-Call Analysis Test
              </h4>
              <p className="text-muted">Answer the question below</p>

              <div className="row g-4 pt-4">
                <div className="col-12 col-md-6">
                  <img
                    src={DummyImg}
                    alt="question"
                    className="img-fluid me-3 w-100 h-100 object-fit-cover rounded-2"
                  />
                </div>
                <div className="col-12 col-md-6 d-flex flex-column gap-2 question-wrapper">
                  <h4 className="text-muted fw-medium">
                    Question {current.id}/{questions.length}
                  </h4>
                  <p>{current.question}</p>
                  <h5 className="text-muted fw-medium mt-3">Choose answer</h5>

                  <div className="option-list">
                    {current.options.map((option, index) => (
                      <div
                        key={index}
                        className={`p-2 mb-2 d-flex align-items-center justify-content-between`}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOptionClick(index)}
                      >
                        <label
                          className="m-0 w-100 d-flex align-items-start"
                          style={{ cursor: "pointer" }}
                        >
                          <input
                            type="radio"
                            name="options"
                            checked={selectedOption === index}
                            onChange={() => handleOptionClick(index)}
                            className="me-2 mt-2"
                            style={{ accentColor: "#198754" }}
                          />
                          {option}
                        </label>
                      </div>
                    ))}
                  </div>

                  <button className="btn btn-success mt-3" onClick={handleNext}>
                    {currentQuestion === questions.length - 1
                      ? "FINISH"
                      : "NEXT"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Congratulations Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className="congratulations"
      >
        <Modal.Body>
          <div className="d-flex flex-column gap-3 justify-content-center text-center">
            <img src={TaskDone} alt="" width={150} className="mx-auto" />
            <h3 className="mb-0">CONGRATULATIONS</h3>
            <p>You passed the test!</p>
            <Button
              variant="primary"
              className="w-fit mx-auto"
              onClick={handleModalNavigate}
            >
              GO TO TEST
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ActualTest;
